import { toast } from 'react-toastify';

import {
  GET_CATEGORIES_REQUEST,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_ERROR,
  GET_AUDIT_CATEGORIES_REQUEST,
  GET_AUDIT_CATEGORIES_SUCCESS,
  GET_AUDIT_CATEGORIES_ERROR,
  CREATE_CATEGORY_REQUEST,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_ERROR,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_ERROR,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_ERROR,
} from './categoryActionTypes';
import call from '../../../core/services/http';
import categoryConstants from './categoryConstants';
import { apiAction } from '../../../core/services/http/apiAction';

const toastrSuccess = (msg) => {
  toast.success(msg);
};
const toastrError = (msg) => {
  toast.error(msg);
};

export const getCategories = (payload) => async (dispatch) => {
  try {
    dispatch({
      type: GET_CATEGORIES_REQUEST,
      isLoading: true,
    });
    const response = await call('get', categoryConstants.GET_CATEGORIES(payload));
    if (response.data.status) {
      dispatch({
        type: GET_CATEGORIES_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_CATEGORIES_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  }catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_CATEGORIES_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_CATEGORIES_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError('Sorry, something went wrong');
    }
  }
};

export const getAuditCategories = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_AUDIT_CATEGORIES_REQUEST,
      isLoading: true,
    });
    const response = await call('get', categoryConstants.GET_AUDIT_CATEGORIES);
    if (response.data.status) {
      dispatch({
        type: GET_AUDIT_CATEGORIES_SUCCESS,
        isLoading: false,
        payload: response.data,
      });
    } else {
      toastrError(response.data.message);
      dispatch({
        type: GET_AUDIT_CATEGORIES_ERROR,
        isLoading: false,
        message: response.data.message,
      });
    }
  } catch (error) {
    console.log('ERROR:', error);
    if (error.response && error.response.status === 400) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_AUDIT_CATEGORIES_ERROR,
        isLoading: false,
        isSuccess: false,
        isRegistered: false,
        message: errorMessage,
      });
      toastrError(errorMessage);
    } else if (error.response && error.response.status === 404) {
      // Handle 400 Bad Request error
      const errorMessage =
        error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Sorry, something went wrong';
      dispatch({
        type: GET_AUDIT_CATEGORIES_ERROR,
        isLoading: false,
        isSuccess: false,
        // message: e.response,
      });
      toastrError(errorMessage);
    } else {
      // Handle other errors (e.g., network issues, server errors)
      console.error('An error occurred:', error);
      toastrError('Sorry, something went wrong');
    }
  }
};
// Renamed from createCustomer/updateCustomer/deleteCustomer, which were the
// asset-class thunks carrying template names.
export const createCategory = (payload) =>
  apiAction({
    types: [CREATE_CATEGORY_REQUEST, CREATE_CATEGORY_SUCCESS, CREATE_CATEGORY_ERROR],
    method: 'post',
    url: categoryConstants.CREATE_CATEGORY,
    data: payload,
    toastOnSuccess: true,
  });

export const updateCategory = ({ id, payload }) =>
  apiAction({
    types: [UPDATE_CATEGORY_REQUEST, UPDATE_CATEGORY_SUCCESS, UPDATE_CATEGORY_ERROR],
    method: 'patch',
    url: categoryConstants.UPDATE_CATEGORY(id),
    data: payload,
    toastOnSuccess: true,
  });

export const deleteCategory = (id) =>
  apiAction({
    types: [DELETE_CATEGORY_REQUEST, DELETE_CATEGORY_SUCCESS, DELETE_CATEGORY_ERROR],
    method: 'delete',
    url: categoryConstants.DELETE_CATEGORY(id),
    toastOnSuccess: true,
  });
